/**
 * External Dependencies
 */
import React, { useCallback, useEffect, useState } from "react";

const Deliveries = ({ onChange, delivery, deliveries = [] }) => {
    const defaultValue = delivery ? delivery : 0;
    const [deliveryId, setDeliveryId] = useState(defaultValue);

    const onDeliveryChange = (event) => {
        let id = parseInt(event.target.value);
        setDeliveryId(id);
        onChange(true, id);
    };

    return (
        <div className="deliveries">
            <div className="cart__select">
                <div className="select">
                    <select value={deliveryId} onChange={onDeliveryChange}>
                        <option value={0}>Select Delivery</option>

                        {deliveries.map(delivery => <option key={delivery.id} value={delivery.id}>{delivery.name}</option>)}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default Deliveries;
